import { createSelector } from 'reselect';
import { GEOFENCES } from '../constants/geofence.constants';
import { initialState } from '../reducers/geofence.reducer';
import {ADMIN_PAGE} from "../../containers/AdminPage/constants";
import {fromJS, List} from "immutable";

const selectState = state => state[GEOFENCES] || initialState;
const selectAdminState = state => state[ADMIN_PAGE] || fromJS({});

const dedupKey = g => {
    if (!g) return '';
    const name = (g.get?.('name') || g.name || '').trim().toLowerCase();
    const accountId = g.get?.('accountId') ?? g.accountId ?? 0;
    return `${accountId}::${name}`;
};

export const selectGeofences = () => createSelector([selectState, selectAdminState], (state, adminState) => {
    let geofences = state.get('data').toList();
    if(!geofences?.size) {
        geofences = List(adminState.get('geofences'));
    }
    // Dedup by name (V3/V4 ids live in disjoint namespaces); V3 wins.
    const v4Geofences = state.get('v4Geofences') || List();
    if (v4Geofences.size) {
        const existingKeys = new Set();
        geofences.forEach(g => { if (g) existingKeys.add(dedupKey(g)); });
        const additions = v4Geofences.filter(g => !existingKeys.has(dedupKey(g)));
        geofences = geofences.concat(additions);
    }
    return geofences.sortBy(g => g.accountName + g.name);
});

export const selectPresence = () => createSelector(selectState, state => state.get('presence'));
export const selectDetailedGeofence = () => createSelector(selectState, state => state.get('detailedGeofence'));
export const selectLoadingDetailedGeofence = () => createSelector(selectState, state => state.get('loading'));
export const selectGeofencesFetched = () => createSelector(selectState, state => state.get('fetched'));
// V3 site ids that have a V4 counterpart — gates the Site picker on V4.
export const selectV4MigratedSiteIds = () => createSelector(selectState, state => {
    const map = state.get('v4SiteMap');
    return map?.keySeq ? map.keySeq().toSet() : new Set();
});
